export const LANGUAGES = [
  { code: "pt", label: "Português", flag: "🇧🇷" },
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "es", label: "Español", flag: "🇪🇸" },
];

export const CURRENCIES = [
  { code: "BRL", symbol: "R$" }, { code: "USD", symbol: "$" }, { code: "EUR", symbol: "€" },
  { code: "GBP", symbol: "£" }, { code: "CAD", symbol: "C$" }, { code: "AUD", symbol: "A$" },
  { code: "JPY", symbol: "¥" }, { code: "CHF", symbol: "CHF" }, { code: "CNY", symbol: "¥" },
  { code: "MXN", symbol: "MX$" },
];

const dict = {
  pt: {
    nav_how: "Como funciona", nav_radar: "Radar mundial", nav_plans: "Planos", nav_login: "Entrar",
    cta_start: "Começar gratuitamente", cta_explore: "Explorar oportunidades",
    hero_title: "ENCONTRE OPORTUNIDADES DE NEGÓCIO NO MUNDO COM IA",
    hero_sub: "Uma inteligência comercial que pesquisa mercados, compara preços, analisa margens e ajuda você a encontrar oportunidades de compra e venda.",
    dash: "Painel", logout: "Sair",
    tab_overview: "Visão Geral", tab_opportunities: "Oportunidades", tab_capital: "Capital",
    tab_calculator: "Calculadora", tab_agents: "Agentes IA", tab_risk: "Risco",
    tab_chat: "Chat IA", tab_settings: "Configurações", tab_plans: "Planos",
    login: "Entrar", register: "Criar conta", email: "Email", password: "Senha", name: "Nome",
    forgot: "Esqueceu a senha?", google: "Continuar com Google", no_account: "Não tem conta?",
    have_account: "Já tem conta?", disclaimer: "Resultados são estimativas. Não há garantia de lucro.",
  },
  en: {
    nav_how: "How it works", nav_radar: "Global radar", nav_plans: "Plans", nav_login: "Sign in",
    cta_start: "Start for free", cta_explore: "Explore opportunities",
    hero_title: "FIND BUSINESS OPPORTUNITIES WORLDWIDE WITH AI",
    hero_sub: "A commercial intelligence that scans markets, compares prices, analyzes margins and helps you find buy & sell opportunities.",
    dash: "Dashboard", logout: "Sign out",
    tab_overview: "Overview", tab_opportunities: "Opportunities", tab_capital: "Capital",
    tab_calculator: "Calculator", tab_agents: "AI Agents", tab_risk: "Risk",
    tab_chat: "AI Chat", tab_settings: "Settings", tab_plans: "Plans",
    login: "Sign in", register: "Create account", email: "Email", password: "Password", name: "Name",
    forgot: "Forgot password?", google: "Continue with Google", no_account: "No account?",
    have_account: "Have an account?", disclaimer: "Results are estimates. Profit is not guaranteed.",
  },
  es: {
    nav_how: "Cómo funciona", nav_radar: "Radar mundial", nav_plans: "Planes", nav_login: "Entrar",
    cta_start: "Empezar gratis", cta_explore: "Explorar oportunidades",
    hero_title: "ENCUENTRA OPORTUNIDADES DE NEGOCIO EN EL MUNDO CON IA",
    hero_sub: "Una inteligencia comercial que investiga mercados, compara precios, analiza márgenes y te ayuda a encontrar oportunidades de compra y venta.",
    dash: "Panel", logout: "Salir",
    tab_overview: "Resumen", tab_opportunities: "Oportunidades", tab_capital: "Capital",
    tab_calculator: "Calculadora", tab_agents: "Agentes IA", tab_risk: "Riesgo",
    tab_chat: "Chat IA", tab_settings: "Ajustes", tab_plans: "Planes",
    login: "Entrar", register: "Crear cuenta", email: "Email", password: "Contraseña", name: "Nombre",
    forgot: "¿Olvidaste la contraseña?", google: "Continuar con Google", no_account: "¿Sin cuenta?",
    have_account: "¿Ya tienes cuenta?", disclaimer: "Los resultados son estimaciones. No se garantiza ganancia.",
  },
};

export function translate(locale, key) {
  return (dict[locale] && dict[locale][key]) || dict.pt[key] || key;
}
